import React from "react";
import Header from "./Header";
import { FaGithub } from "react-icons/fa";

const TicketCard = ({ fileBase64, fullName, githubUsername }) => {

    const randomId = Math.floor(100000 + Math.random() * 900000);


    return (
        <div className="relative flex flex-col bg-gray-700  rounded-xl shadow-lg p-6 gap-4 space-y-4">
            <p className="absolute top-4 right-4 bg-black p-2 rounded-xl">UID: <span className="text-gray-300">#{randomId}</span></p>
            <Header />

            <div className="flex items-center space-x-4">
                <img
                    src={fileBase64}
                    alt="Uploaded file"
                    className="w-16 h-16 border-2 border-gray-300 rounded-full object-cover"
                />

                <div className="flex flex-col">
                    <p className="font-semibold text-xl">{fullName}</p>
                    <p className="text-lg flex justify-center items-center gap-2">
                        <FaGithub className="text-gray-400 font-bold"/>
                        @{githubUsername}</p>
                </div>
            </div>
        </div>
    );
};

export default TicketCard;
